import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getIsGreaterChinaSalesOrg } from '../../gamedayAccount/selectors';
import { getUserData } from '../../user/selectors';
import { getChinaProvinceFromCode } from '../../util/languageTranslations';

const Address = ({ address, isGreaterChinaSalesOrg, locale }) => {
  if (!address) return null;

  const addressVals =
    address &&
    Object.keys(address).reduce((addr, val) => {
      const updatedAddr = addr;
      updatedAddr[val] = address[val].value;
      return updatedAddr;
    }, {});

  const {
    addressName,
    addressName2,
    streetAddressLine1,
    streetAddressLine2,
    streetAddressLine3,
    cityName,
    provinceStateCode,
    postalCode,
    countryCode,
    locationDescription,
    districtName,
    shopSuiteFloor
  } = addressVals;
  return (
    addressVals && (
      <p translate='no'>
        <span className='body-3'>
          {/* nickname */}
          {addressName && (
            <>
              {addressName}
              <br />
            </>
          )}
          {/* attention */}
          {addressName2 && (
            <>
              {addressName2}
              <br />
            </>
          )}
        </span>
        {/* shopSuiteFloor */}
        <span className='body-4 text-color-secondary'>
          {shopSuiteFloor && (
            <>
              {shopSuiteFloor} <br />
            </>
          )}
          {/* address */}
          {streetAddressLine1 && (
            <span>
              {streetAddressLine1}
              <br />
            </span>
          )}
          {streetAddressLine2 && (
            <>
              {streetAddressLine2}
              <br />
            </>
          )}
          {streetAddressLine3 && (
            <>
              {streetAddressLine3}
              <br />
            </>
          )}
          {/* district */}
          {isGreaterChinaSalesOrg && districtName && (
            <>
              {districtName} <br />
            </>
          )}
          <span>{cityName}</span>
          {(provinceStateCode?.length || postalCode?.length || countryCode?.length) && <>, </>}
          <abbr>
            {isGreaterChinaSalesOrg ? getChinaProvinceFromCode(locale, provinceStateCode) : provinceStateCode}
          </abbr>
          <> </>
          <span>{postalCode}</span>
          <> </>
          <abbr>{countryCode}</abbr>
          {locationDescription && (
            <>
              <br />
              {locationDescription}
            </>
          )}
        </span>
      </p>
    )
  );
};

Address.propTypes = {
  address: PropTypes.object.isRequired,
  isGreaterChinaSalesOrg: PropTypes.bool.isRequired,
  locale: PropTypes.string
};

Address.defaultProps = {
  locale: ''
};

const mapStateToProps = state => ({
  isGreaterChinaSalesOrg: getIsGreaterChinaSalesOrg(state),
  locale: getUserData(state)?.locale
});

const connector = connect(mapStateToProps, null);

export default connector(Address);
